import { motion } from "framer-motion"
import StaggerText from "react-stagger-text"


export default function BottomFooter(){

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // Smooth scrolling behavior
        });
      };
    
      const arrowVariants = {
        default: {
          y: 0,
        },
        hover: {
          type: "circInOut",
          bounce: 2,
          y: -4,
          transition: { duration: 0.2, yoyo: 1 },
        },
        click: {
          type: "spring",
          bounce: -1,
          duration: 0.2,
        },
      };
    
      const renderArrowIcon = () => (
        <motion.div variants={arrowVariants} className="up-icon">
          <i
            className="bi bi-arrow-up-short"
            style={{ color: "#000", fontSize: "2.1em" }}
          ></i>
        </motion.div>
      );
    return(
        <motion.div
        initial={{
          y: 20,
          opacity: 0,
        }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: false }}
        className="bottom-footer"
      >
        <p>
          {" "}
          <StaggerText>©2022 ABDUL SABOOR</StaggerText>{" "}
        </p>

        <a
          href="mailto:abdulsaboormillwala123@gmail.com"
          className="chonkyunderline "
        >
          saboordevelops@gmail.com
        </a>
        <p>
            <StaggerText>

          Built by Saboor with
            </StaggerText>
            {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="red"
            className="bi bi-heart-fill"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
            />
          </svg>
        </p>
        <motion.div
          whileHover="hover"
          whileTap={{ scale: 0.97, bounce: 2 }}
          className="position-relative"
          onClick={scrollToTop}
        >
          {renderArrowIcon()}
        </motion.div>
      </motion.div>
    )
}